<header class="topbar">
    <div class="topbar-main">
        <a href="#" id="menu-button" (click)="app.onMenuButtonClick($event)" aria-label="menu button">
            <span class="fa fa-bars"></span>
        </a>
        <a [routerLink]="['/card']">
            <img alt="main logo" style="max-height: 30px; width: auto;" width="auto"
                onerror="this.src='assets/img/strat-logo.png';" src="{{app.logoURL}}" class="logo">
        </a>
        <a href="#" id="user-display" (click)="app.onTopbarMenuButtonClick($event)">
            <span class="username">{{app.firstName}} {{app.lastName}}</span>
            <span class="userrole"><span style="display:inline-block; margin-right: 0;"
                    *ngIf="app.email">{{app.email}}</span>
                ({{app.userName}})</span>
            <img alt="main logo" src="assets/layout/images/avatar5.png">
        </a>
        <nav>
            <ul id="topbar-menu" class="fadeInDown animated" style="right:0 !important; width:200px !important;"
                [ngClass]="{'topbar-menu-visible': app.topbarMenuActive}">
                <li class="menuitem-active">
                    <a class="cursorPointer" (click)="app.account()">
                        <i class="topbar-icon fa fa-fw fa-user"></i>
                        <span class="topbar-item-name">User Profile</span>
                    </a>
                </li>
                <li class="menuitem-active">
                    <a class="cursorPointer" (click)="app.organization()">
                        <i class="topbar-icon fa fa-fw fa-sitemap"></i>
                        <span class="topbar-item-name" *ngIf="!app.singleOrgAppFlag">Organization</span>
                        <span class="topbar-item-name" *ngIf="app.singleOrgAppFlag">Organizations</span>
                    </a>
                </li>
                <li class="menuitem-active">
                    <a class="cursorPointer" (click)="app.logmeout()">
                        <i class="topbar-icon fa fa-fw fa-user"></i>
                        <span class="topbar-item-name">Logout</span>
                    </a>
                </li>

                <li class="menuitem-active" *ngIf="app.singleOrgAppFlag && app.organizationDataList.length!=0">
                    <a>
                        <i class="topbar-icon fa fa-fw fa-cubes"></i>
                        <span class="topbar-item-name">CHANGE CONTEXT</span>
                    </a>
                    <ul>
                        <li role="menuitem" *ngFor="let x of app.organizationDataList">
                            <a class="cursorPointer" (click)="app.selectOrganization(x)">
                                <div class="p-2  ellipsis">
                                    <span style="width:25px;">
                                        <i class="fa fa-check" *ngIf="x.isRight"></i>
                                        &nbsp;
                                    </span>
                                    {{x.name}}
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </nav>
    </div>

    <app-menu [reset]="app.resetMenu"></app-menu>

</header>